export const mobileLandingPage = {
    form: {
        inputPhoneTitle: '请输入有效的手机号码',
        inputNameTitle: '请输入姓名',
        inputValidPhone: '请输入有效的手机号码',
        validCodeError: '验证码错误',
        successMessage: '提交成功，我们将尽快与您联系，请注意接听电话。',
        name: '您的姓名',
        namePlaceholder: '请输入姓名',
        phone: '联系电话',
        phonePlaceholder: '请输入手机号',
        validCode: '验证码',
        validCodePlaceholder: '请输入验证码',
        sending: '{count}秒后发送',
        send: '发送验证码',
        connectUs: '联系我们',
    },
    title: {
        downloadApp: '下载',
        free: '免费试用',
        cloudService: '云服务·尊享版',
        intelligentDesign: '智能设计',
        pad: '福昕智装App',
    },
    freeTest: {
        saveCode: '保存二维码，微信扫码关注公众号',
        message1: '关注',
        message2: '【福昕家装云服务】',
        message3: '公众号 点击底部菜单',
        message4: '「新手攻略」',
        message5: '「免费试用」',
        message6: '获取试用资格，体验家装项目协作管理',
    },
    cloudService: {
        title1: '精量图纸共享',
        subTitle1: '一方上传资料，同步至相关联的多方，业主无需多次重复配合。',
        title2: '专人专项负责',
        subTitle2:
            '在资料对应位置@对应的负责人进行问题的推进，不会分散无关人员的精力。',
        title3: '问题精准定位',
        subTitle3:
            '在资料对应位置精准查看问题推进的过程和结果，不受其它无关问题的干扰。',
        title4: '结果实时通知',
        subTitle4:
            '问题推进的过程和结果自动实时通知，若是理解不一致，可以及时纠偏。',
        title5: '进度计划跟踪',
        subTitle5:
            '更加直观的进度计划表，对应位置跟踪和汇报对应问题，集中精力。',
        title6: '过程验收记录',
        subTitle6: '对应计划对应验收记录，适时把控落地效果。',
        title7: '避免过程风险',
        subTitle7:
            '开工前/完工前自动实时通知，避免延期；工期变更业主签名，方便追溯避免扯皮。',
        message1: '限时免费，火热进行中~',
        message2: '福昕家装云服务',
        message3: '尊享版',
        message4: '为品质家装提供个性化的项目管理服务',
        message5: '立即体验',
        message6: '福昕家装公众号',
        message7: '施工图纸协作',
        message8: '高效沟通·实时共享',
        message9: '施工计划协作',
        message10: '科学施工·进度透明',
        message11: '立即咨询',
        message12: '免费试用',
    },
    intelligentDesign: {
        message1: '福昕家装',
        message2: '智能设计',
        message3: '让设计更高效，让家装更省心',
        message4: '申请试用',
        message5: '携手数字化，共赴新征程',
        message6: '家装行业一体化解决方案',
        message7: '双剑合璧，化解多方"信任危机',
        message8: '施工图、施工进度点对点沟通，打通沟通壁垒',
        message9:
            '施工阶段，使用福昕家装·云服务，减少施工图错漏、施工现场协调难题和返工，缩短项目交付时间，增强项目可控性。',
        message10: '了解云服务',
        message11: '行业合作伙伴',
        message12: '一体化解决方案达成共赢',
        message13: '申请试用',
        message14: '快速上手，高效设计',
        message15: '多场景应用，精细化管理，助力行业数字化转型',
        message16: '极速渲染 卓越品质',
        message17: '自研渲染引擎，效果一键生成，满足多种场景下的出图需求',
        message18: '高清大图 立等可取',
        message19: '拥有丰富的可视化模型、材质资源，落地效果轻松掌控',
        message20: '灵活布光',
        message21: '一键灯光布置，支持创建多种布光方案',
        message22: '即将上线，敬请期待',
        message23: '快速出图',
        message24: '1分钟出2K图，渲染颠覆性提速 ',
        message25: '真实还原',
        message26: '最高8K渲染，还原商品形状、材质纹理等细节',
        message27: '下载福昕智装',
    },
    intelligentDesignPad: {
        message1: '福昕智装APP',
        message2: '半天掌握3D户型设计、渲染、分享获客',
        message3: '下载福昕智装',
        message4: '平台已包含5.8w+商品',
        message5: '福昕家装会不断丰富商品，满足业主多样化的需求',
        message6: '共享商品数字模型',
        message7:
            '仅需在福昕家装·云服务的资源库上传模型、材质、贴图后，共享给平台。',
        message8: '半天学会，上手无忧',
        message9: '专业服务，一天超神',
        message10: '立即咨询',
        message11: '立即下载',
        message12: '长按关注视频号',
        message13: '官方客服',
        message14: '了解智能设计',
        message15: '产品总览',
        advertisement1:
            '将您的商品上传到福昕家装·云服务，与+7.5亿潜在客户分享，提高您的品牌知名度',
        advertisement2:
            '几分钟内为您的客户创建有吸引力的3D设计，加大整装签单概率',
        advertisement3: '几分钟内为您的客户场景化展示商品，提升商品销量',
        production1: '智能设计·桌面端',
        production2: '福昕智装·移动端',
        production3: '云服务·尊享版',
        production4: '云服务·企业版',
        productionDesc1: '随身必备的装修3D设计运营神器',
        productionDesc2: '智能化、BIM化室内设计软件',
        productionDesc3: '为品质家装提供个性化项目管理服务',
        productionDesc4: '数据赋能装企，专注项目生命周期管理',
    },
    benefit: {
        message1: '限时抢购',
        message2: '注：最终解释权归福昕家装所有',
    },
    useSuccess: {
        copySuccess: '复制成功',
        allow: '会员资格已开通',
        expired: '免费试用已到期',
        open: '快去试用吧～',
        copyLink: '复制链接去电脑端使用',
        message1:
            '1、在电脑端「项目管理」-「试用项目」中上传施工图纸、创建施工节点进行项目协同',
        message2:
            '2、关注【福昕家装云服务】公众号，点击「云服务-尊享版」，可以对项目的施工图、进度计划进行实时协同',
    },
    successTip: {
        submitSuccess: '提交成功！',
        submitSuccessMessage: '唤醒微信客服，回复 “问题关键词序号”',
        submitSuccessMessage1: '可加快申请通过速度',
        submitSuccessMessage2: '点击去唤醒',
    },
};
